export default __webpack_public_path__ + "static/media/Group 10647.154c7c35.svg";